<template>
  <div class="main-box">
    <div v-if="!success">
      <div class="title">log off the user</div>
      <div class="desc">
        Please note that once your account is cancelled, we will process your
        personal information in accordance with the requirements of laws and
        regulations, including but not limited to deletion or anonymization.
        Before then, make sure you back up the data you want to keep. After an
        account is cancelled, you will not be able to restore the account or any
        information contained in it.
      </div>
      <el-form
        label-position="right"
        label-width="80px"
        ref="loginForm"
        :rules="rules"
        :model="loginForm"
      >
        <el-form-item label="username" prop="username" style="width: 88%">
          <el-input v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item label="password" prop="password" style="width: 88%">
          <el-input type="password" v-model="loginForm.password"></el-input>
        </el-form-item>
        <el-button type="primary" @click="submitForm('loginForm')"
          >Confirm cancellation
        </el-button>
      </el-form>
    </div>
    <div v-else class="success-div">
      <i class="el-icon-finished"></i>
      &nbsp;
      <span>Logout successful</span>
    </div>

    <div class="bottom-box">©2024-2030 SmartOb, Inc. All rights reserved.</div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      success: false,
      rules: {
        username: [
          {
            required: true,
            message: "please enter your username",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "please enter the password",
            trigger: "blur",
          },
        ],
      },
      captchaImg: "",
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          axios({
            method: "post",
            url: "/app/user/writeOff",
            data: {
              username: this.loginForm.username,
              password: this.loginForm.password,
            },
          })
            .then((res) => {
              // console.log(res.data)
              // 将token存储到应用store中
              if (res.data.code == "0000") {
                this.success = true;
              }
            })
            .catch((error) => {
              // this.getCaptcha();
              console.log("error submit!!");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.main-box {
  width: 1280px;
  margin: 0 auto;
  overflow-y: hidden;
}

.bottom-box {
  position: absolute;
  width: 100%;
  text-align: center;
  color: #888888;
  bottom: 15px;
  left: 0;
}

.title {
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 24px;
}

.desc {
  width: 100%;
  /* text-align: center; */
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 24px;
  color: gray;
}

.success-div {
  margin-top: 200px;
  font-size: 26px;
  font-weight: 600;
  color: green;
}
</style>
